import Api from './Api'

export default {
  getFailedOppgjor (queryParams) {
    return Api().get('/logg/find-failed-oppgjor.json', {
      params: queryParams
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/InvoiceLoggService.js